<template>
  <div
    v-if="modelValue"
    ref="container"
    :class="['floating-drawing', { dragging: dragging }]"
    :style="{ top: posY + 'px', left: posX + 'px', width: windowWidth ? windowWidth + 'px' : null }"
  >
    <div class="drawing-header" @mousedown.stop="startDrag">
      <h6 class="m-0"><b>{{ tituloFinal }}</b></h6>
      <button class="btn-close btn-close-white" @click.stop="close"></button>
    </div>

    <img v-if="imageSrc" :src="imageSrc" class="drawing-img" />
    <div
      class="resize-handle-left"
      aria-label="Redimensionar janela"
      @mousedown.prevent.stop="startResizeLeft"
    ></div>
  </div>
</template>

<script>
import img1 from "../components/img/calculator-shell-cilind-internal-press/drawing-shell-cilind-internal-press.png"
import img2 from "../components/img/calculator-spherical-shells-press-concave/drawing-spherical-shells-press-concave.png"
import img3 from "../components/img/calculator-shell-conical-internal-press/drawing-shell-conical-internal-press.png"
import img4 from "../components/img/calculator-ellipsoidal-head-press-concave/drawing-ellipsoidal-head-press-concave.png"
import img5 from "../components/img/calculator-torisple-head-press-concave/drawing-torisple-head-press-concave.png"
import img6 from "../components/img/calculator-flange-integral/drawing-flange-integral.png"
import img7 from "../components/img/calculator-bocal/drawing-bocal.png"

export default {
  name: "DesenhoApoio",

  props: {
    modelValue: Boolean,
    tipo: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: "Desenho de apoio"
    }
  },

  data() {
    return {
      desenhos: [
        { tipo: 1, nome: "Shell Cilind Internal Press", imagem: img1 },
        { tipo: 2, nome: "Spherical Shells Press Concave", imagem: img2 },
        { tipo: 3, nome: "Shell Conical Internal Press", imagem: img3 },
        { tipo: 4, nome: "Ellipsoidal Head Press Concave", imagem: img4 },
        { tipo: 5, nome: "Torispherical Head Press Concave", imagem: img5 },
        { tipo: 6, nome: "Flange Integral", imagem: img6 },
        { tipo: 7, nome: "Bocal", imagem: img7 }
      ],

      posX: 220,
      posY: 160,
      dragging: false,
      offsetX: 0,
      offsetY: 0,
      windowWidth: null,
      resizingLeft: false,
      resizeStartX: 0,
      resizeStartLeft: 0,
      resizeStartWidth: 0
    }
  },

  computed: {
    desenhoSelecionado() {
      return this.desenhos.find(d => d.tipo === this.tipo)
    },
    imageSrc() {
      return this.desenhoSelecionado?.imagem || null
    },
    tituloFinal() {
      return this.desenhoSelecionado?.nome || this.title
    }
  },

  watch: {
    modelValue(val) {
      if (val) {
        this.$nextTick(() => {
          this.fixInitialPosition()
          document.addEventListener("click", this.handleClickOutside)
        })
      } else {
        document.removeEventListener("click", this.handleClickOutside)
      }
    }
  },

  methods: {
    fixInitialPosition() {
      const container = this.$refs.container
      const width = container ? container.offsetWidth : 400
      const height = container ? container.offsetHeight : 220
      const padding = 12

      const rightInset = window.innerWidth <= 991 ? 24 : 170

      if (window.innerWidth <= 991) {
        this.posX = Math.max(padding, window.innerWidth - width - rightInset)
        this.posY = 180
      } else {
        this.posX = Math.max(padding, window.innerWidth - width - rightInset)
        this.posY = 250
      }

      const maxX = Math.max(padding, window.innerWidth - width - rightInset)
      const maxY = Math.max(padding, window.innerHeight - height - padding)

      this.posX = Math.min(Math.max(this.posX, padding), maxX)
      this.posY = Math.min(Math.max(this.posY, padding), maxY)
    },

    close() {
      this.$emit("update:modelValue", false)
    },

    startDrag(e) {
      this.dragging = true
      this.offsetX = e.clientX - this.posX
      this.offsetY = e.clientY - this.posY

      document.addEventListener("mousemove", this.onDrag)
      document.addEventListener("mouseup", this.stopDrag)
    },

    onDrag(e) {
      if (!this.dragging) return

      const container = this.$refs.container
      if (!container) return

      const padding = 12
      const maxX = Math.max(padding, window.innerWidth - container.offsetWidth - padding)
      const maxY = Math.max(padding, window.innerHeight - container.offsetHeight - padding)

      this.posX = Math.min(Math.max(e.clientX - this.offsetX, padding), maxX)
      this.posY = Math.min(Math.max(e.clientY - this.offsetY, padding), maxY)
    },

    stopDrag() {
      this.dragging = false
      document.removeEventListener("mousemove", this.onDrag)
      document.removeEventListener("mouseup", this.stopDrag)
    },

    startResizeLeft(e) {
      const container = this.$refs.container
      if (!container) return

      this.resizingLeft = true
      this.resizeStartX = e.clientX
      this.resizeStartLeft = this.posX
      this.resizeStartWidth = container.offsetWidth
      this.windowWidth = container.offsetWidth

      document.addEventListener("mousemove", this.onResizeLeft)
      document.addEventListener("mouseup", this.stopResizeLeft)
    },

    onResizeLeft(e) {
      if (!this.resizingLeft) return

      const padding = 12
      const minWidth = Math.min(260, window.innerWidth - (padding * 2))
      const rightEdge = this.resizeStartLeft + this.resizeStartWidth
      const maxWidth = rightEdge - padding
      const requestedWidth = this.resizeStartWidth - (e.clientX - this.resizeStartX)
      const width = Math.min(Math.max(requestedWidth, minWidth), maxWidth)

      this.windowWidth = width
      this.posX = rightEdge - width
    },

    stopResizeLeft() {
      this.resizingLeft = false
      document.removeEventListener("mousemove", this.onResizeLeft)
      document.removeEventListener("mouseup", this.stopResizeLeft)
    }
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside)
    document.removeEventListener("mousemove", this.onResizeLeft)
    document.removeEventListener("mouseup", this.stopResizeLeft)
  },

}
</script>

<style scoped>
.floating-drawing {
  position: fixed;
  width: min(400px, calc(100vw - 24px));
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 24px);
  min-width: 260px;
  min-height: 180px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.2);
  z-index: 9999;
  resize: both;
  overflow: hidden;
  user-select: none;
}

h6 {
  color: white;
}

.btn-close-white {
  opacity: 1;
}

.drawing-header {
  background: #0056FF;
  color: white;
  cursor: move;
  padding: 6px 10px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.drawing-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.resize-handle-left {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 18px;
  height: 18px;
  cursor: sw-resize;
}

.img-drawing {
  width: 900px !important;
}

.dragging {
  cursor: grabbing !important;
}

/* CELULAR */
@media (max-width: 768px) {
  .floating-drawing {
    width: min(300px, calc(100vw - 24px));
  }
}

/* TABLET */
@media (min-width: 768px) and (max-width: 991px) {
  .floating-drawing {
    width: min(360px, calc(100vw - 24px));
  }
}

</style>